/**
 * Dynamic Configuration Service
 * Automatically resolves the backend address based on the current environment.
 */

const HOSTNAME = window.location.hostname;
const PROTOCOL = window.location.protocol;

// Use 'wss:' if the site is running on https, otherwise 'ws:'
const WS_PROTOCOL = PROTOCOL === "https:" ? "wss:" : "ws:";

// Check if we are running in development (localhost or raw IP address)
const isDevelopment =
    HOSTNAME === "localhost" ||
    HOSTNAME === "127.0.0.1" ||
    /^(\d{1,3}\.){3}\d{1,3}$/.test(HOSTNAME);

// Backend Ports: 
// In production (itkalka.in), Nginx handles the ports, so we leave them empty.
const BACKEND_PORT = isDevelopment ? ":8000" : "";
const SOCKET_IO_PORT = isDevelopment ? ":5000" : "";

// Base URLs
// Note: We keep the trailing slashes to match standard Django REST framework patterns
export const API_BASE_URL = `${PROTOCOL}//${HOSTNAME}${BACKEND_PORT}/api/`;
const BASE_URL = `${PROTOCOL}//${HOSTNAME}${BACKEND_PORT}`;

export const MEDIA_BASE_URL = `${BASE_URL}/media/`;
/** * WS_BASE_URL:
 * In Dev: ws://localhost:8000/ws/chat/
 * In Prod: wss://itkalka.in/ws/chat/
 * (Nginx will route /ws/ to the Daphne server on 8001)
 */
export const WS_BASE_URL = `${WS_PROTOCOL}//${HOSTNAME}${BACKEND_PORT}/ws/chat/`;
export const WS_NOTIF_URL = `${WS_PROTOCOL}//${HOSTNAME}${BACKEND_PORT}/ws/notifications/`;

// If you are using a separate Socket.io server (Node.js) on port 5000
export const SOCKET_IO_URL = `${PROTOCOL}//${HOSTNAME}${SOCKET_IO_PORT}`;

const config = {
    API_BASE_URL,
    WS_BASE_URL,
    WS_NOTIF_URL,
    SOCKET_IO_URL,
};

export default config;
